module.exports = __webpack_public_path__ + "img/house-door.935a8a63.svg";